import script from "./Rejects8dList.vue?vue&type=script&setup=true&lang=js"
export * from "./Rejects8dList.vue?vue&type=script&setup=true&lang=js"

import "./Rejects8dList.vue?vue&type=style&index=0&id=ebe665a2&lang=scss"

const __exports__ = script;

export default __exports__